import { createFileRoute } from "@tanstack/react-router";
import { AdminLayout } from "@/components/admin/AdminLayout";
import { MediaManager } from "@/components/admin/MediaManager";

export const Route = createFileRoute("/admin/media")({
  component: MediaPage,
  head: () => ({
    meta: [
      { title: "Media Manager — Admin" },
      { name: "description", content: "Manage media files and uploads" },
    ],
  }),
});

function MediaPage() {
  return (
    <AdminLayout>
      <MediaManager />
    </AdminLayout>
  );
}
